import { RoleEnum } from '../enums/roleEnum';

// Platform commission and order-deposit settings (fe-guide-admin, advance payment §7).

/**
 * The permissions behind both payment settings screens.
 *
 * `admin.superadmin` and a full Admin pass both; AuthService.hasAdminPermission() handles that.
 */
export const PaymentSettingsPermissions = {
  View: 'paymentSettings.view',
  Manage: 'paymentSettings.manage',
} as const;

// The routes, the sidenav items and the landing redirect all spread this, so what a SubAdmin can
// see and what they can open cannot drift apart.
export const PAYMENT_SETTINGS_ACCESS = {
  roles: [RoleEnum.Admin, RoleEnum.SubAdmin],
  permission: PaymentSettingsPermissions.View,
};

/** Both are null until the first change. */
interface SettingsAuditStamp {
  updatedAt: string | null;
  updatedByUserId: string | null;
}

export interface CommissionSettings {
  ratePercent: number;
  /** SAR, before VAT, per payment. */
  capSar: number;
}

export interface CommissionSettingsDto extends CommissionSettings, SettingsAuditStamp {}

/** An omitted field keeps its current value. */
export type UpdateCommissionSettingsRequest = Partial<CommissionSettings>;

export const DEPOSIT_BASE = { FullTotal: 0, GoodsOnly: 1 } as const;

/** Sent whole on save: the PUT is a full replace. */
export interface OrderDepositSettings {
  /** DEPOSIT_MODE values. Empty = suppliers cannot offer deposits. */
  allowedModes: number[];
  depositBase: number;
  checkoutWindowHours: number;
  payByWindow: { allowed: boolean; minHours: number; maxHours: number };
  voluntaryRefund: { allowed: boolean; responseWindowHours: number };
}

export interface OrderDepositSettingsDto extends OrderDepositSettings, SettingsAuditStamp {}

/** One line of a confirm dialog: an edited setting, old value to new, already worded for display. */
export interface SettingChange {
  label: string;
  from: string;
  to: string;
}
